<ebw-monorepo-sidebar-header [icon]="'flowchart'" [title]="'map.sidebar.tracing.title'" [isSvg]="false" [isOutline]="false">
</ebw-monorepo-sidebar-header>

<div class="container">
  <section class="info-section">
    <mat-icon>info_outline</mat-icon>
    <div class="info-text">
      <!-- {{ 'map.sidebar.otdr.FAS.info_section' | translate }} -->
        Abilitare il click su mappa e selezionare punto di partenza.
        Se si sceglie shortest path, selezionare su mappa anche punto di arrivo.
        Se si sceglie trace out, inserire un valore in metri.
    </div>
  </section>
  <form class="tracing-form" autocomplete="off">
    <!-- Campo di partenza -->
    <div class="form-section">
      <mat-form-field appearance="outline">
        <mat-label>Ricerca punto di partenza</mat-label>
        <input matInput [value]="startPoint" disabled />
      </mat-form-field>
      <button mat-icon-button color="primary" (click)="toggleCustomClick('start')">
        <mat-icon matTooltip="Clicca qua per selezionare dalla mappa">{{ clickSource == 'start' ? 'cancel' : 'search' }}</mat-icon>
      </button>
    </div>

    <!-- Toggle -->
    <mat-slide-toggle [(ngModel)]="isTraceOut" name="toggle" color="primary" (change)="onEventToggle($event)">
      {{ isTraceOut ? 'Trace Out' : 'Shortest Path' }}
    </mat-slide-toggle>

    <!-- Condizione: Shortest Path -->
    <div class="form-section" *ngIf="!isTraceOut">
      <mat-form-field appearance="outline">
        <mat-label>Ricerca punti di arrivo</mat-label>
        <input matInput [value]="endPoint" disabled />
      </mat-form-field>
      <button mat-icon-button color="primary" (click)="toggleCustomClick('end')">
        <mat-icon matTooltip="Clicca qua per selezionare dalla mappa">{{ clickSource == 'end' ? 'cancel' : 'search' }}</mat-icon>
      </button>
    </div>

    <!-- Condizione: Trace Out -->
    <div class="form-section" *ngIf="isTraceOut">
      <mat-form-field appearance="outline">
        <mat-label>Distanza (metri)</mat-label>
        <input matInput type="number" [(ngModel)]="distance" name="distance" required min="1" />
      </mat-form-field>
    </div>

    <!-- Bottone di ricerca -->
    <button mat-raised-button color="primary" (click)="submitSearch()">Cerca</button>
    <button mat-raised-button color="secondary" (click)="onReset()">Ripristina</button>
  </form>
</div>



